// Constants
const GTM_ID = "GTM-5RXJ9L5P";
const COOKIE_CONSENT_KEY = "cookieConsent";
const DOMAIN =
  window.location.hostname === "988lifeline.org"
    ? ".988lifeline.org"
    : undefined;

var cc_banner = document.getElementById("cookie-consent-actual");

// Initialize dataLayer and define gtag function
window.dataLayer = window.dataLayer || [];
function gtag() {
  window.dataLayer.push(arguments);
}

// Set default consent to denied before GTM loads
gtag("consent", "default", {
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
  analytics_storage: "denied",
});

// Dynamically load GTM script
(function loadGTM() {
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l !== "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", GTM_ID);
})();

// Dynamically add GTM noscript fallback
(function loadGTMNoScript() {
  const noscript = document.createElement("noscript");
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.appendChild(noscript);
})();

// Handle user acceptance of cookies
function handleAccept() {
  cc_banner.style.display = "none";

  // Store consent in cookies
  Cookies.set(COOKIE_CONSENT_KEY, "granted", { expires: 365, domain: DOMAIN });

  // Grant all consent categories
  gtag("consent", "update", {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
  });

  // Log the acceptance event
  gtag("event", "cookie_consent", {
    consent_status: "granted",
  });
}

// Handle user rejection of cookies
function handleReject() {
  cc_banner.style.display = "none";

  // Store rejection in cookies
  Cookies.set(COOKIE_CONSENT_KEY, "denied", { expires: 365, domain: DOMAIN });

  // Deny all consent categories
  gtag("consent", "update", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
  });

  // Log the rejection event
  gtag("event", "cookie_consent", {
    consent_status: "denied",
  });
}

// Handle closing of the banner without making a selection
function handleClose() {
  cc_banner.style.display = "none";
}

// Check consent state from cookies
function checkConsentState() {
  const consentStatus = Cookies.get(COOKIE_CONSENT_KEY);

  if (!consentStatus) {
    // Show the banner if no consent status exists
    cc_banner.style.display = "block";
  } else if (consentStatus === "granted") {
    // Apply granted consent
    gtag("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      analytics_storage: "granted",
    });
  } else if (consentStatus === "denied") {
    // Apply denied consent
    gtag("consent", "update", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
    });
  }
}

document.addEventListener("readystatechange", () => {
  if (document.readyState === "interactive") {
    checkConsentState();
  }
});
